/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { UserDetails } from 'app/user-auth/models';
import { Observable } from 'rxjs';
import { observableOf } from 'app/shared/rxjs/rxjs.utils';
import { TenantDetails } from 'app/page-modules/tenant-management/models';

/** Auth0 implementation of Auth service. */
@Injectable()
export class MockAuthService extends AuthService {
  private accessToken?: string;

  getRequestHeaders(): HttpHeaders {
    if (this.accessToken) {
      return new HttpHeaders().set('Authorization', 'Bearer ' + this.accessToken);
    }
    return new HttpHeaders();
  }

  setAccessToken(token: string): void {
    this.accessToken = token;
  }

  constructor() {
    super();
    console.info(`
    --------------------------
    Authentication is disabled
    --------------------------
    `);
  }

  authenticate(): Observable<UserDetails> {
    return observableOf({
      name: 'Naeem Bukhari',
      picture: 'assets/cool-pic.jpeg',
      email: 'naeem.bukhari@opengamma.com',
      roles: []
    });
  }

  unauthenticate(): void {}

  canLoginToTenant(userDetails: UserDetails, tenantDetails: TenantDetails): boolean {
    return true;
  }

  requiresLoginReason(tenantDetails: TenantDetails): boolean {
    return true;
  }

  loginToTenant(
    tenantClientId: string,
    orgId?: string,
    previewEnvironment?: string
  ): Observable<void> {
    return observableOf();
  }
}
